import { render } from "./EmployerManageCards.vue?vue&type=template&id=2461d05b&scoped=true"
import script from "./EmployerManageCards.vue?vue&type=script&lang=js"
export * from "./EmployerManageCards.vue?vue&type=script&lang=js"

import "./EmployerManageCards.vue?vue&type=style&index=0&id=2461d05b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2461d05b"]])

export default __exports__